var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2744",
    "data-name": "Group 2744",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2009",
    "data-name": "Path 2009",
    d: "M0,0H19V19H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2010",
    "data-name": "Path 2010",
    d: "M4,17.625a6.333,6.333,0,1,1,12.667,0H15.083a4.75,4.75,0,1,0-9.5,0ZM10.333,10.5a4.75,4.75,0,1,1,4.75-4.75A4.749,4.749,0,0,1,10.333,10.5Zm0-1.583A3.167,3.167,0,1,0,7.167,5.75,3.166,3.166,0,0,0,10.333,8.917Z",
    transform: "translate(-0.833 -0.208)",
    fill: "#2863ff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/GroupIcon.0257380c5097f74fb842656c2dd6bc24.svg";
export { ForwardRef as ReactComponent };